import React, { useState } from 'react';
import { getParameter } from "../utilities/urlUtil";
import { urlParams, blacklistRegex } from "../constants";
import img from "../../../public/assets/images/magnif_icon_red2018.jpg";

function searchBoxes(value) {
    var popsearch = value;

    if (popsearch != '') {
        var path = 'SearchResults.aspx?Keyword=';
        popsearch = popsearch.replace(blacklistRegex, '');
        popsearch = encodeURIComponent(popsearch);
        popsearch = popsearch.replace(/%20/g, '+');
        path = path + popsearch + '&sc=BM&fi=1&fr=1';
        window.location.href = path;
    }
}

function SearchBar(props) {
    const [searchValue, setSearchValue] = useState("");

    const performSearch = () => {
        searchBoxes(searchValue);
    };

    const onKeyEntered = (e) => {
        if (e.keyCode == 13 || e.charCode == 13) {
            searchBoxes(searchValue);
        }
    };

    const onSearchbarChange = (e) => {
        if (blacklistRegex.test(e.target.value)) {
            e.preventDefault();
            e.stopPropagation();
        }
        else {
            setSearchValue(e.target.value);
        }
    };

    let isPaidSearchCampaign = getParameter(urlParams.paidSearch) === "1";

    return (
        !isPaidSearchCampaign  && <div className="pop-searchbar col-12">
            <div className="searchbar-wrapper m-auto" id="boxinput">
                <label
                    className="input-label"
                    htmlFor="popsearch"
                >
                    Submit Search
                </label>
                <input type="text" id="popsearch"
                    value={searchValue}
                    size="30"
                    maxLength="250"
                    placeholder="Search W.B. Mason"
                    onKeyPress={onKeyEntered}
                    onChange={onSearchbarChange}
                />
                <img src={img}
                    onClick={performSearch}
                    alt="Find"
                    style={{ cursor: "pointer" }}
                />
            </div>   
        </div>
        );

}

export default SearchBar;